export default __webpack_public_path__ + "static/media/google.51b37718.png";